
export const preferences = {
  namespaced: true,
  state: {
    hideRouteHowTo: false,
  },
  mutations: {
    set (state, payload) {
      if (state.hasOwnProperty(payload.key)) {
        state[payload.key] = payload.val;
      }
    },
    toggle(state, key) {
      if (state.hasOwnProperty(key)) {
        state[key] = ! state[key];
      }
    },

  },
  getters: {

  },
  actions: {

  }
};



// WEBPACK FOOTER //
// ./src/modules/store/preferences.js